<template>
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#"><i class="fa fa-bars"></i></a>
      </li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link" href="#" @click="logout()">
            <i class="fa fa-fw fa-power-off"></i> 登出
        </a>
      </li>
    </ul>
  </nav>
</template>
<script>
  export default {
    methods: {
      logout(){
        this.swalProccess('資料處理中')
        this.$store.dispatch('admin/logout', this.loginForm).then(() => {
          this.swalClose()
          this.swalMsg('成功', '', 'success', this.$router.push({ path: '/login' }))
        }).catch(() => {
          this.swalClose()
          this.swalMsg('成功', '', 'success', this.$router.push({ path: '/login' }))
        })
      }
    }
  }
</script>